module.exports = __webpack_public_path__ + "static/media/SealCheckDark.cad34a09.svg";